export const date2ts = date => Math.ceil(date.valueOf() / 1000)



// WEBPACK FOOTER //
// ./packages/utils/date.js